<template>
    <div class="bom">
      <div class="bom_mi">
        <div>
          <img class="bom_mi-logo" src="/static/img/Group_bom.png" alt="" @click="goHome" />
          <div class="testtwo">MFO AllianceFinance</div>
          <div class="testtwo" style="margin-top: 0.08rem;">Мы предоставляем быстрые и надежные микрозаймы онлайн для граждан Казахстана.</div>
          <div class="testtwo" style="margin-top: 0.08rem;">БИН：251240006742</div>
          <div class="mne">
            <img class="pol" src="/static/img/mastercar.png" alt="" />
            <img class="mnh" src="/static/img/visa.png" alt="" />
          </div>
        </div>
        <div class="bom_micon">
          <div class="bom_micon-text">Информация</div>
          <div class="bom_con-text" style="margin-bottom: 0.08rem;" @click="goHome">Главная страница</div>
          <div class="bom_con-text" style="width: 1.42rem;cursor: pointer;margin-bottom: 0.08rem;" @click="getprivacy">Политика конфиденциальности</div>
          <div class="bom_con-text" style="width: 1.65rem;cursor: pointer;" @click="getdocument">документ</div>
        </div>
        <div class="bom_micon">
          <div class="bom_micon-text">Свяжитесь с нами</div>
          <div class="bom_cont" style="margin-bottom: 0.08rem;">
            <img class="bom_cont-img" src="/static/img/Group_94.png" alt="" />
            <div class="bom_cont-text">+7 778 325 9734</div>
          </div>
          <div class="bom_cont" style="margin-bottom: 0.08rem;">
            <img class="bom_cont-img" src="/static/img/Group_95.png" alt="" />
            <div class="bom_cont-text">info@kzcredit.kz</div>
          </div>
          <div class="bom_contwo">
            <img class="bom_cont-img" src="/static/img/Group_96.png" alt="" />
            <div class="bom_cont-text" style="width: 2.05rem;">Казахстан, город Алматы, Бостандыкский район, улица Розыбакиева, дом 279, кв. 80, почтовый индекс 050000</div>
          </div>
        </div>
      </div>
      <div class="iug">ТОО «МФО Alliance Finance», Лицензия на осуществление микрофинансовой деятельности № 02.26.0004.М, от 20.05.2026года года, выдана Управлением региональных представителей в городе Алматы Агентства Республики Казахстан по регулированию и развитию финансового рынка.</div>
    </div>
</template>

<script>
  export default {
    name: "BomTab",
    props: {
      jumpindex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
      };
    },
    mounted () {
    },
    methods: {
      goHome() {
        if (this.$route.path === '/') {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return
        }
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          })
        })
      },
      getprivacy(){
        location.href = "https://kzcredit.kz/privacy.html"
      },
      getdocument(){
        if (this.$route.path === '/conte') {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return
        }
        this.$router.push('/conte').then(() => {
          this.$nextTick(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          })
        })
      }
    },
  };
</script>

<style scoped>
    .bom{
      background: #0F172AFF;
      padding: 0.52rem 1.58rem;
    }
    .bom_mi{
      display: flex;
      justify-content: space-between !important;
    }
    .bom_mi-logo{
      width: 1.11rem;
      height: 0.32rem;
      margin-bottom: 0.1rem;
      cursor: pointer;
    }
    .testtwo{
      width: 1.61rem;
      color: #94a3b8ff;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 0.07rem;
      line-height: 0.1rem;
      text-align: left;
    }
    .mne{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 0.19rem;
    }
    .pol{
      width: 0.41rem;
      height: 0.26rem;
      margin-right: 0.1rem;
    }
    .mnh{
      width: 0.41rem;
      height: 0.26rem;
    }
    .bom_micon-text{
      color: #ffffffff;
      font-family: Montserrat;
      font-weight: 700;
      font-size: 0.1rem;
      margin-bottom: 0.16rem;
    }
    .bom_con{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .bom_con-text{
      color: #94a3b8ff;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 0.08rem;
      cursor: pointer;
    }
    .bom_cont{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .bom_contwo{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }
    .bom_cont-img{
      width: 0.22rem;
      height: 0.22rem;
      margin-right: 0.06rem;
    }
    .bom_cont-text{
      color: #94a3b8ff;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 0.09rem;
    }
    .iug{
      margin-top: 0.41rem;
      color: #64748bff;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 0.09rem;
      line-height: 0.11rem;
      text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/BomTab.vue